<template>
  <div class="iphone-block">
    <div class="iphone-head">
      <div class="this-time">{{time}}</div>
    </div>
    <div class="iphone-inner">
      <transition
        v-on:before-leave="beforeLeave"
        v-on:before-enter="beforeEnter"
        v-on:after-enter="afterEnter"
      >
        <component :is="screen" :event="event" :post="post" :profile="profile"></component>
      </transition>
      <section class="menu-zone" ref="menuZone">
        <ThemedMenuZone :primary="current_style.primary" :class="{active: mActive==='news'}">
          <SvgIcon name="news_ico" width="18" height="18"></SvgIcon>
          <ThemedMenuCaption :font="current_style.font">Новости</ThemedMenuCaption>
        </ThemedMenuZone>
        <ThemedMenuZone :primary="current_style.primary" :class="{active: mActive==='photos'}">
          <SvgIcon name="photo_ico" width="22" height="22"></SvgIcon>
          <ThemedMenuCaption :font="current_style.font">Снимки</ThemedMenuCaption>
        </ThemedMenuZone>
        <ThemedMenuZone :primary="current_style.primary" :class="{active: mActive==='profile'}">
          <SvgIcon name="user_ico" width="22" height="22"></SvgIcon>
          <ThemedMenuCaption :font="current_style.font">Информация</ThemedMenuCaption>
        </ThemedMenuZone>
      </section>
    </div>

    <div class="iphone-bg"></div>
  </div>
</template>

<script>
  import moment from 'moment'
  import Profile from './screens/Profile.vue'
  // import EventStart from "./screens/EventStart.vue";
  import EventPost from './screens/EventPost.vue'
  import ThemedMenuZone from './styled-components/ThemedMenuZone'
  import ThemedMenuCaption from './styled-components/ThemedMenuCaption'
  import { Default_style } from '../../library/lib'
  import { createNamespacedHelpers } from 'vuex'

  const {mapGetters} = createNamespacedHelpers('design')

  export default {
    name: 'IphoneMoc',
    components: {
      Profile,
      // EventStart,
      EventPost,
      ThemedMenuZone,
      ThemedMenuCaption
    },
    props: ['event', 'post', 'screen', 'sideLeave', 'sideEnter', 'profile'],
    data() {
      return {
        time: moment().format('HH:mm'),
        mActive: ''
      }
    },
    methods: {
      menuActive: function (t) {
        if (t === 'hide') this.$refs.menuZone.style.display = 'none'
        else {
          this.$refs.menuZone.style.display = 'grid'
        }
      },
      beforeLeave: function (el) {
        let way = 290
        way *= this.sideLeave === 'left' ? -1 : 1
        el.style = 'transform:translateX(' + way + 'px)'
      },
      beforeEnter: function (el) {
        let way = 290
        way *= this.sideEnter === 'left' ? -1 : 1
        el.style = 'transform:translateX(' + way + 'px)'
      },
      afterEnter: function (el) {
        el.style = 'transform:translateX(0)'
      }
    },
    computed: {
      ...mapGetters(['styles']),
      current_style() {
        if ((this.event === undefined) || (this.event.style_id === undefined) || (this.event.style_id === ''))
          return Default_style()
        else {
          return this.styles.find(style => style.id === this.event.style_id).style_json
        }
      },
    },
    mounted() {
      setInterval(() => {
        this.time = moment().format('HH:mm')
      }, 1000)
    },
  }
</script>

<style lang="scss" scope>
  @font-face {
    font-family: "SF pro";
    src: url("~@/assets/fonts/SF-Pro-Text-Regular.otf") format("opentype");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "SF pro display";
    src: url("~@/assets/fonts/SF-Pro-Display-Regular.woff") format("woff"),
    url("~@/assets/fonts/SF-Pro-Display-Regular.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
  }

  .iphone-block {
    user-select: none;
    height: 638px;
    width: 330px;
    display: flex;
    flex-wrap: wrap;
    // align-items: center;
    justify-content: center;
    position: relative;

    .iphone-head {
      position: relative;
      top: 22px;
      width: 268px;
      height: 31px;
      background-color: #fff;
      z-index: 1;
    }

    .this-time {
      position: absolute;
      font-family: "SF pro";
      top: 16px;
      left: 15px;
      z-index: 1;
      font-size: 11px;
      font-weight: bold;
    }

    .iphone-inner {
      width: 268px;
      height: 562px;
      // top: -22px;
      overflow: hidden;
      background-color: #f8f8f8;
      position: relative;

      .profile-screen {
        height: 100%;
      }

      .screen {
        padding: 40px 10px;
        height: 100%;
        // transition: all 0.3s;
        h3 {
          font-weight: bold;
          font-size: 22px;
          line-height: 30px;
          color: #333;
          margin-bottom: 0;
        }
      }

      .pic-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        position: relative;
        height: 187px;
        width: 100%;
        // top: 31px;

        .layout {
          position: absolute;
          top: 0;
          left: 0;
          background-repeat: no-repeat !important;
          background-size: cover !important;
          height: 144px;
          width: 100%;
          border-bottom: 1px solid $lightCalm;

          &.layDefault {
            background: url("~@/assets/layout.png");
          }
        }

        .avatar {
          position: relative;
          z-index: 1;
          width: 90px;
          height: 90px;
          margin-right: 12px;
          @include border($lightCalm);
          border-radius: 90px !important;
          border: none;

          background-repeat: no-repeat !important;
          background-size: cover !important;

          &.avatarDefault {
            background: url("~@/assets/photo.png");
          }
        }
      }

      .form-wrap {
        margin-top: -11px;
        padding-left: 15px;
        padding-right: 15px;
        top: -35px;
        position: relative;

        .name {
          font-weight: bold;
          margin-top: 14px;
          margin-bottom: 6px;
          font-size: 16px;
          line-height: 24px;
          max-width: 153px;
          text-overflow: ellipsis;
          max-height: 63px;
          overflow: hidden;

          &.overflowed {
            position: relative;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 16px;
              bottom: 0;
              left: 0;
              background: linear-gradient(
                  180deg,
                  rgba(248, 248, 248, 0) 0%,
                  #f8f8f8 83.98%
              );
            }
          }
        }

        .regdate {
          color: $calmColor;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 18px;
        }

        .btn-wrap {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 8px;
          margin-bottom: 16px;

          .pse-btn {
            display: flex;
            padding: 8px;
            justify-content: center;
            font-weight: normal;
            font-size: 14px;
            background: rgba($mainColor, 0.1);
            @extend %bRadius;
            color: $mainColor;
            opacity: 0.3;
            transition: opacity 0.3s;

            &.active {
              opacity: 1;
            }
          }
        }

        .contact-wrap {
          .title {
            font-weight: bold;
            font-size: 13px;
            margin-bottom: 8px;
            display: block;
          }

          .contact-row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            opacity: 0.3;
            transition: opacity 0.3s;
            padding: 7px 10px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.08);

            &.active {
              opacity: 1;
            }

            .ico-wrap {
              flex: 0 0 25px;
              margin-right: 8px;
              max-width: 25px;
              text-align: left;

              .icon {
                color: $mainColor;
              }
            }

            .link {
              font-size: 13px !important;
              // flex: 1 0 auto;
              display: flex;
              align-items: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              justify-content: space-between;
              width: 100%;

              .forward-icon {
                display: inline-block;
                color: #bbbbbb;
              }
            }
          }
        }
      }

      .menu-zone {
        position: absolute;
        bottom: 0;
        width: 100%;
        background: #fff;
        padding: 7px 15px 10px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        border-top: 1px solid $lightCalm;

        .menu-item {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #8e8e8e;
          transition: color 0.3s;

          span {
            padding-top: 3px;
            font-size: 11px;
          }

          &.active {
            color: $mainColor;
          }
        }
      }
    }

    //iphone inner
    .iphone-bg {
      pointer-events: none;
      position: absolute;
      z-index: 10;
      top: 0;
      background-image: url("~@/assets/iphone_no_clock.png");
      background-position: top left;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      height: 100%;
    }
  }
</style>
